module.exports = __webpack_public_path__ + "assets/img/preview_01.8f62bc14.png";